import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import CrossSVG from "assets/images/cross.svg.svg";

type Props = {
  name?: String;
  petName?: String;
  handleClose?: any;
  open?: any;
};

const PetArchivePopUp = ({ handleClose, open }: Props) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{}}
        fullWidth
      >
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>
          <div className="tw-flex tw-flex-col tw-gap-4 tw-p-4 tw-bg-white tw-rounded-[1.625rem] tw-opacity-100">
            {/* 1st col */}
            <div className="tw-flex tw-items-center tw-justify-end">
              <div
                className="tw-relative tw-w-fit tw-p-2 tw-rounded-[50%] tw-border-[1px] tw-border-intenseRed"
                onClick={handleClose}
              >
                <img src={CrossSVG} alt=""/>
              </div>
            </div>
            {/* 2nd col */}
            <div className="tw-flex tw-flex-col tw-gap-12">
              {/* 1st inner col */}
              <DialogContentText>
                <div className="tw-text-[0.875rem] lg:tw-text-[1.125rem] tw-text-darkPurple tw-font-medium">
                  Are you Sure you want to archive your pet?
                </div>
              </DialogContentText>

              {/* 2nd inner col*/}
              <div className="tw-flex tw-items-center tw-justify-end tw-gap-8">
                <button
                  className="tw-border-[1px] tw-border-black tw-text-[0.875rem] lg:tw-text-[1.125rem] tw-font-light tw-py-0.5 lg:tw-py-1.5 tw-px-4 lg:tw-px-8 tw-rounded-[0.625rem]"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button className=" tw-text-[0.875rem] lg:tw-text-[1.125rem] tw-text-white tw-font-light tw-py-1 lg:tw-py-1.5 tw-px-4 lg:tw-px-8 tw-rounded-[0.625rem] tw-bg-[#FF503D]  ">
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PetArchivePopUp;
